  <template>
    <div class="my">
      <div class="grid-one" hidden="true">
        <p class="f-18 f-w">商城服务</p>
        <van-grid :border='false'>
          <van-grid-item :icon="img.order" text="我的订单" />
          <van-grid-item :icon="img.redpack" text="我的红包" />
          <van-grid-item :icon="img.integer" text="我的积分" />
          <van-grid-item :icon="img.location" text="我的地址" @click="pageUrl('/lexus/my/address')" />
        </van-grid>
      </div>
      <div class="grid-one">
        <p class="f-18 f-w">我的服务</p>
        <van-grid :border='false'>
         <!-- <van-grid-item :icon="img.post" text="我的发布" @click="pageUrl('/lexus/my/bbs')"/>
         <van-grid-item :icon="img.comment" text="我的评论" @click="pageUrl('/lexus/my/comment')" /> -->
         <!-- <van-grid-item :icon="img.ask" text="我的问答" @click="pageUrl('/lexus/my/ask')"/> -->
         
         <!-- <van-grid-item :icon="img.collect" text="我的收藏" @click="pageUrl('/lexus/my/collect')"/> -->
         <!-- <van-grid-item :icon="img.history" text="浏览记录" @click="pageUrl('LexusMyCookies')" /> -->
         <van-grid-item :icon="img.memberinfo" text="我的信息" @click="pageUrl('/lexus/my/info')" />
         <van-grid-item :icon="img.approve" text="车主认证" @click="pagecarsUrl('/lexus/my/cars')" />
         <van-grid-item :icon="img.message" text="我的消息" @click="pageUrl('/lexus/my/message')" />
         <van-grid-item :icon="img.safety" text="账号安全" @click="pageUrl('/lexus/my/safety')" />
       </van-grid>
     </div>
     <div class="grid-box" hidden="true">
      <p class="f-18 f-w">我的荣耀</p>
      <van-grid :border='false'>
        <van-grid-item :icon="img.honor" text="荣耀勋章" @click="pageUrl('/lexus/my/honour')"/>
        <van-grid-item :icon="img.grade" text="我的等级" @click="pageUrl('/lexus/my/grade')" />
        <van-grid-item :icon="img.fans" text="我的粉丝" @click="pageUrl('/lexus/my/fanslist/0')" />
        <van-grid-item :icon="img.active" text="我的活动" @click="pageUrl('/lexus/my/active')" />
        <van-grid-item icon="" text="" />
        <van-grid-item icon="" text="" />
        <van-grid-item icon="" text="" />
       <!--  <van-grid-item :icon="img.sign" text="我的打卡" />
        <van-grid-item :icon="img.ranking" text="我的排行榜" />
        <van-grid-item :icon="img.mycar" text="我的爱车"  /> -->
      </van-grid>
    </div>
    <div class="btn-box" v-if="islogin">
      <van-button type="default" size="large" @click='exit'>退出</van-button>
    </div>
  </div>
</template>
<script>
  import common from '../../../api/common';
  import {Grid, GridItem,Button } from "vant";
  import { mapState } from 'vuex';
  import list from '../../../api/member/mycars';
  export default {
    data () {
      return {
        islogin:false,
        img: {
         order: require('../../../assets/img/lexus/member/order.png'),
         redpack: require('../../../assets/img/lexus/member/redpack.png'),
         integer: require('../../../assets/img/lexus/member/integer.png'),
         transfer: require('../../../assets/img/lexus/member/transfer.png'),
         post: require('../../../assets/img/lexus/member/post.png'),
         comment: require('../../../assets/img/lexus/member/comment.png'),
         ask: require('../../../assets/img/lexus/member/ask.png'),
         message: require('../../../assets/img/lexus/member/message.png'),
         honor: require('../../../assets/img/lexus/member/honor.png'),
         grade: require('../../../assets/img/lexus/member/grade.png'),
         fans: require('../../../assets/img/lexus/member/fans.png'),
         sign: require('../../../assets/img/lexus/member/sign.png'),
         active: require('../../../assets/img/lexus/member/active.png'),
         ranking: require('../../../assets/img/lexus/member/ranking.png'),
         memberinfo: require('../../../assets/img/lexus/member/memberinfo.png'),
         safety: require('../../../assets/img/lexus/member/safety.png'),
         approve: require('../../../assets/img/lexus/member/approve.png'),
         mycar: require('../../../assets/img/lexus/member/mycar.png'),
         location: require('../../../assets/img/lexus/member/location.png'),
         history: require('../../../assets/img/lexus/member/history.png'),
         collect: require('../../../assets/img/lexus/member/collect.png'),
       }
     }
   },
   computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    this.weburl=process.env.VUE_APP_URL
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
        this.islogin=true
      } 
    })
    var params={
      event_code: '我的服务',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/My.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  activated () {
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
        this.islogin=true
      } 
    })
  },
  methods: {
    pageUrl(url){
      this.$appService.getToken(v => {
        if(v.token) {
          var params={
            url:this.weburl+url+'?source='+this.source,
            isReturn: true 
          }
          this.$appService.openWebView(params)
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:this.weburl+url+'?source='+this.source,
            pagetype:2,
            isReturn: true 
          }
          this.$appService.needLogin(params)
        }
      })
    },
    pagecarsUrl(){
      var params={
        brand_id: 1
      }
      list.getMycars(params).then(res => {
        if(res.data.state == 1) {
          let list=res.data.data
          
          if(list.length>0){
            var params={
              url:this.weburl+'/lexus/my/cars?source='+this.source,
              isReturn: true 
            }
            this.$appService.openWebView(params)
          }else{
            var params={
              url:this.weburl+'/lexus/my/approve?source='+this.source,
              isReturn: true 
            }
            this.$appService.openWebView(params)
          }
        }
      })
    },
    exit(){
      this.$dialog.confirm({
        message: '确定要退出凌志范儿吗？'
      }).then(() => {
        axios.defaults.headers.common['Authorization'] = null
        this.$store.commit('param/token', '')
        this.$toast('退出成功')
        Lockr.flush()
        this.$appService.needLogout()
        
        this.islogin=false
        this.$router.replace({ name: 'LexusHome' })
      }).catch(() => {
      });
    },
  },
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]:Button 
  }
}
</script>
<style lang="scss">
.my{
  margin-bottom: 60px;
  .grid-box{
    border-top: 10px solid #eaeaea;
    padding: 0 15px;
    min-height: 260px;
  }
  .grid-one{
    padding: 0 15px;
  }
  .btn-box{
    text-align: center;
    margin-top: 40px;
    .van-button{
      width: 90%;
    }
  }
  .van-icon__image{
    width: 20px;
    height: 20px;
  }
}
</style>